import styled, { css } from 'styled-components';
import { minDesktopMediaQuery, resolveResponsiveProp } from '../../styles';
import { IconSize, IconType } from './Icon.constants';
export const IconRoot = styled.svg.withConfig({
  shouldForwardProp: propName => !['iconColor', 'iconType', 'size'].includes(propName)
}).withConfig({
  componentId: "ds__sc-dmxhj1-0"
})(["", " flex-shrink:0;", ""], _ref => {
  let {
    size
  } = _ref;
  const strokeChange = css(["vector-effect:non-scaling-stroke;stroke-width:1px;"]);
  return css(["", " ", " path{", "}"], resolveResponsiveProp('width', size), resolveResponsiveProp('height', size), Array.isArray(size) ? css(["", " ", ""], size[0] === IconSize.EXTRA_SMALL ? strokeChange : '', size[1] === IconSize.EXTRA_SMALL ? css(["@media (", "){", "}"], minDesktopMediaQuery(), strokeChange) : '') : size === IconSize.EXTRA_SMALL ? strokeChange : '');
}, _ref2 => {
  let {
    iconType,
    iconColor
  } = _ref2;
  if (iconType === IconType.REGULAR) {
    return css(["stroke:", ";"], iconColor);
  }
  if (iconType === IconType.TYPE_30) {
    return css(["fill:", ";"], iconColor);
  }
});